import Block from "base/Block";
// import { Fancybox } from "@fancyapps/ui";

class PricePage extends Block {
	static get blockName() {
		return 'b-price-page';
	}

	onInit() {
		// 	//TODO: костыль для закрытия fancybox, исправить в дальнейшем
		// 	document.removeEventListener("fancybox.close", this._closeHandler);
		// 	this._closeHandler = () => Fancybox.close();
		// 	document.addEventListener("fancybox.close", this._closeHandler);

		// 	this.jsonData = [];

		// 	this.filteredData = [];
		// 	this.directionId = '';
		// 	this.dropdownOpen = false;

		// 	this.searchValue = '';

		// 	this.initTabsClicnis();
		// 	this.openListener();

		// 	this.initData();

		// 	let timeout;
		// 	const search = this.el.querySelector('.b-price-page__search input');
		// 	if (search) {
		// 		search.addEventListener('input', () => {
		// 			clearTimeout(timeout);
		// 			timeout = setTimeout(() => {
		// 				this.searchValue = search.value.toLowerCase();
		// 				this.applyFilter();
		// 			}, 300)
		// 		})
		// 	}
		// }

		// initData() {
		// 	fetch('/api/getallprice/')
		// 		.then(response => response.json())
		// 		.then(jsonData => {
		// 			this.jsonData = jsonData.data;
		// 			// console.log('Загрузка полоного дерева');
		// 			// console.log(this.jsonData);
		// 			// console.log('==================================');
		// 			this.initFilterDropdown();
		// 			this.initPopularDirections();
		// 		})
		// }
		// //фильтр по направлениям
		// initFilterDropdown() {
		// 	const filterSect = this.el.querySelector('.b-price-page__filter')
		// 	const toggleBtn = this.el.querySelector('.b-price-page__filter-btn');
		// 	const dropdown = this.el.querySelector('.b-price-page__filter-container');
		// 	const options = this.el.querySelectorAll('.b-price-page__filter-option');

		// 	if (!toggleBtn || !dropdown) return;

		// 	// TODO; отказаться от установки по умолчании, (по началу вывод ~5-6 направлений), реализовать кнопку показать еще;

		// 	// const firstOption = options[0];
		// 	// if (firstOption) {
		// 	// 	this.directionId = firstOption.dataset.value;
		// 	// }

		// 	//открытие/закрытие фильтра
		// 	toggleBtn.addEventListener('click', () => {
		// 		this.dropdownOpen = !this.dropdownOpen;
		// 		dropdown.classList.toggle('b-price-page__filter-container--hide', !this.dropdownOpen);
		// 	})

		// 	//выбор опции
		// 	options.forEach(option => {
		// 		option.addEventListener('click', () => {
		// 			this.setDirectionFilter(option.dataset.value);

		// 			//закрывае выпадающий список
		// 			this.dropdownOpen = false;
		// 			dropdown.classList.add('b-price-page__filter-container--hide');
		// 		})
		// 	})

		// 	//клик вне
		// 	document.addEventListener('click', (e) => {
		// 		if (!filterSect.contains(e.target) && this.dropdownOpen) {
		// 			this.dropdownOpen = false;
		// 			dropdown.classList.add('b-price-page__filter-container--hide');
		// 		}
		// 	});
		// }

		// initPopularDirections() {
		// 	const popularItems = this.el.querySelectorAll('.' + this.blockName + '__top-directions-item');

		// 	popularItems.forEach(item => {
		// 		item.addEventListener('click', () => {
		// 			this.setDirectionFilter(item.dataset.value);
		// 		})
		// 	});
		// }

		// // управление фильтром
		// setDirectionFilter(value) {
		// 	this.directionId = this.directionId === value ? '' : value;

		// 	//обновляем популярные направления
		// 	const popularItems = this.el.querySelectorAll('.' + this.blockName + '__top-directions-item');
		// 	popularItems.forEach(item => {
		// 		item.classList.toggle('is-selected', item.dataset.value === this.directionId);
		// 	});

		// 	//обновляем выпадающий список
		// 	const dropdownOptions = this.el.querySelectorAll('.b-price-page__filter-option');
		// 	dropdownOptions.forEach(option => {
		// 		option.classList.toggle('b-price-page__filter-option--is-selected', option.dataset.value === this.directionId);
		// 	});

		// 	this.applyFilter();
		// }

		// applyFilter() {
		// 	if (!this.jsonData.length) return;

		// 	// this.showLoader();

		// 	let result = [...this.jsonData];

		// 	if (this.searchValue) {
		// 		result = this.filterSearch(result, this.searchValue);
		// 		// console.log('работает поиск');
		// 		// console.log(result);
		// 		// console.log('==================================');
		// 	}
		// 	// TODO:возможно переделать сейчас то что вывел поиск фильтруется если выбрано определенное направление;
		// 	console.log(this.directionId);
		// 	if (this.directionId) {
		// 		result = result.filter(item => item.id == this.directionId);
		// 		// console.log('работает фильтр по направелению');
		// 		// console.log(result);
		// 		// console.log('==================================');
		// 	}

		// 	this.filteredData = result;
		// 	this.render();
		// }

		// render() {
		// 	const list = this.el.querySelector('.b-price-page__price-list');

		// 	if (!this.filteredData || !this.filteredData.length) {
		// 		list.innerHTML = `<div>Ничего не найдено</div>`;
		// 		return;
		// 	}

		// 	if (list) {
		// 		list.innerHTML = this.filteredData.map(direction => `
		// 			<div class="b-price-page__direction">
		// 				<div class="b-price-page__direction-head">
		// 					<h2 class="b-price-page__direction-title">${direction.name}</h2>
		// 					<div class="b-price-page__direction-title-icn">
		// 						<svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" fill="none" viewBox="0 0 14 8">
		// 							<path stroke="#3356a3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7 7 1 1 7"/>
		// 						</svg>
		// 					</div>
		// 				</div>
		// 				<div class="b-price-page__direction-sections">
		// 					${this.renderServices(direction.services || [])}
		// 					${this.renderDirectionPrices(direction.prices || [], direction.name || '')}
		// 				</div>
		// 			</div>
		// 		`).join('');
		// 		this.openListener();
		// 		this.initNewFormButton();
		// 	}
		// }

		// //рендер цен направления
		// renderDirectionPrices(prices, directionName) {
		// 	if (!prices || !prices.length) return '';

		// 	return `
		// 		<div class="b-price-group">
		// 			<h3 class="b-price-group__title">${directionName}</h3>
		// 			<ul class="b-price-group__items">
		// 				${this.renderPrices(prices)}
		// 			</ul>
		// 		</div>
		// 	`;
		// }

		// //рендер услуг
		// renderServices(services) {
		// 	if (!services || !services.length) return ''

		// 	return services.map(service => `
		// 		<div class="b-price-group">
		// 			<h3 class="b-price-group__title">${service.name}</h3>
		// 			${(service.prices && service.prices.length) > 0 ? `<ul class="b-price-group__items">${this.renderPrices(service.prices || [])}</ul>` : ''}
		// 			${this.renderSubServices(service.subservices || [])}
		// 		</div>
		// 		`).join('');
		// }

		// //рендер подуслуг
		// renderSubServices(subservices) {
		// 	if (!subservices || !subservices.length) return '';

		// 	return subservices.map(sub => `
		// 			<div class="b-price-group__sublevel">
		// 				<h4 class="b-price-group__subtitle">
		// 					${sub.name}
		// 				</h4>
		// 				<ul class="b-price-group__items">
		// 					${this.renderPrices(sub.prices || [])}
		// 				</ul>
		// 			</div>
		// 		`).join('');
		// }

		// //рендер цен
		// renderPrices(prices) {
		// 	if (!prices || !prices.length) return '';

		// 	return prices.map(price => `
		// 			<li class="b-price-item">
		// 				<div class="b-price-item__left">
		// 					<p class="b-price-item__name">${price.name}</p>
		// 					<p class="b-price-item__code">${price.official_code}</p>
		// 				</div>
		// 				<div class="b-price-item__right">
		// 					<p class="b-price-item__price">${price.value} ₽</p>
		// 					<a href="#prices" class="b-price-item__link js-open-popup">Записаться</a>	
		// 				</div>
		// 			</li>
		// 		`).join('');
		// }

		// //проверка на совпаденице
		// matchesSearch(price, searchValue) {
		// 	const name = (price.name || '').toLowerCase();
		// 	return name.includes(searchValue);
		// }

		// //рекурсия для поиска цены по дереву
		// filterSearch(data, searchValue) {
		// 	if (Array.isArray(data)) {
		// 		return data.map(item => this.filterSearch(item, searchValue)).filter(item => item !== null);
		// 	}

		// 	if (typeof data !== 'object' || data === null) {
		// 		return data;
		// 	}

		// 	//проврка на контейнер (направление, услуга, подуслуга)
		// 	const isContainer = data.services || data.subservices || data.prices;

		// 	if (isContainer) {
		// 		const filtered = { ...data };
		// 		const nestedKeys = ['services', 'prices', 'subservices'];

		// 		for (const key of nestedKeys) {
		// 			if (filtered[key]?.length) {
		// 				filtered[key] = this.filterSearch(filtered[key], searchValue);
		// 			}
		// 		}

		// 		const hasData = nestedKeys.some(key => filtered[key]?.length > 0);
		// 		return hasData ? filtered : null
		// 	}

		// 	return this.matchesSearch(data, searchValue) ? data : null
		// }

		// openListener() {
		// 	const wrap = this.el.querySelectorAll('.' + this.blockName + '__direction');
		// 	wrap.forEach(item => {
		// 		if (this.searchValue !== '') {
		// 			item.classList.add('open');
		// 		}
		// 	})

		// 	const show = this.el.querySelectorAll('.' + this.blockName + '__direction-head');
		// 	show.forEach(item => {
		// 		item.addEventListener('click', (e) => {
		// 			const parent = e.target.closest('.' + this.blockName + '__direction');
		// 			if (parent) {
		// 				parent.classList.toggle('open');
		// 			}
		// 		});
		// 	})
		// }

		// //табы по клиинкам
		// initTabsClicnis() {
		// 	const tabsEl = this.el.querySelector('.tab');
		// 	if (!tabsEl) return;

		// 	const tabBtns = tabsEl.querySelectorAll('.' + this.blockName + '__clinics-tab');
		// 	tabBtns.forEach(btn => {
		// 		btn.addEventListener('click', (e) => this.onTabClick(e, btn))
		// 	})
		// }

		// onTabClick(e, btn) {
		// 	const tabsEl = btn.closest('.tab');
		// 	if (!tabsEl) return;

		// 	if (btn.classList.contains('active')) return;

		// 	const targetId = btn.dataset.targetId,
		// 		targetPane = tabsEl.querySelector(`[data-id="${targetId}"]`);

		// 	if (targetPane) {
		// 		const activeBtn = tabsEl.querySelector('.active');
		// 		const activePane = tabsEl.querySelector('.show');

		// 		if (activeBtn) activeBtn.classList.remove('active');
		// 		if (activePane) activePane.classList.remove('show');

		// 		btn.classList.add('active');
		// 		targetPane.classList.add('show');
		// 	}
		// }

		// initNewFormButton() {
		// 	// Ищем кнопки внутри нашего списка цен
		// 	const priceList = this.el.querySelector('.b-price-page__price-list');
		// 	if (!priceList) return;

		// 	let newFormButton = priceList.querySelectorAll('.js-open-popup');

		// 	newFormButton.forEach((el) => {
		// 		let src = el.getAttribute('href');

		// 		// Вешаем клик
		// 		if (document.querySelector(src)) {
		// 			el.addEventListener('click', function (e) {
		// 				e.preventDefault();
		// 				Fancybox.show([{ src: src, type: "inline" }]);
		// 			});
		// 		}
		// 	});
		// }

		//TODO: доделать loader
		// showLoader() {
		// 	const list = this.el.querySelector('.b-price-page__price-list');
		// 	if (list) {
		// 		list.innerHTML = `
		// 				<span class="b-price-page__loader"></span>
		// 		`
		// 	}
	}
}

Block.register(PricePage);

export default PricePage;